import { useMemo } from "react";
import { motion } from "framer-motion";

export default function Machines({ products, onSelect, filter, setFilter }) {
  const categories = useMemo(() => ["All", ...new Set(products.map((p) => p.category))], [products]);
  const visible = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <section id="machines" data-testid="machines-section" className="bg-[#F4F5F7]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20">
        <h2 className="text-center text-3xl font-light uppercase tracking-wide text-[#222] sm:text-4xl" data-testid="machines-heading">
          Product Catalogue
        </h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-sm leading-relaxed text-muted-foreground">
          The complete Penta Laser range - dual table and single table flatbeds, tube and H-beam processing, 3D five-axis systems and fully automated production lines.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-2" data-testid="machine-filters">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => setFilter(c)}
              className={`border px-4 py-2 text-xs font-semibold uppercase tracking-wide transition-colors duration-150 ${
                filter === c ? "border-laser bg-laser text-white" : "border-border bg-white text-muted-foreground hover:border-laser hover:text-laser"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((m, i) => (
            <motion.button
              key={m.id}
              data-testid={`machine-card-${m.id}`}
              onClick={() => onSelect(m)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              className="group bg-white text-left shadow-[0_2px_12px_rgba(0,0,0,0.08)] transition-shadow duration-200 hover:shadow-[0_6px_24px_rgba(0,0,0,0.14)]"
            >
              <div className="relative overflow-hidden bg-[#EDEFF2]">
                <img src={m.image} alt={m.name} loading="lazy" className="aspect-[4/3] w-full object-cover object-[center_35%] transition-transform duration-300 group-hover:scale-105" />
                <span className="absolute bottom-0 left-0 bg-laser px-3 py-1.5 text-xs font-semibold text-white">{m.category}</span>
              </div>
              <div className="p-4">
                <h3 className="text-[15px] font-medium text-[#333] transition-colors group-hover:text-laser">{m.name}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-muted-foreground">{m.tagline}</p>
                {m.power && m.power !== "-" && <p className="mt-2 text-xs font-semibold text-navy">{m.power}</p>}
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
